/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import BackSections from "../Giftcards/BackSections";
import yourCard from "../../Assets/youregift.png";
import qr from "../../Assets/qrcode.png";
import { decryptAES } from "../../Common/Axios/encrypt";
import copyIcon from "../../Assets/copy.png";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import {
  onGeOrderCodeReset,
  onGetOrderCode,
} from "../../Store/Slices/getOrderCodeSlice";
import pointiconImage from "../../Assets/point_icon.svg";
import axiosInstanceClient from "../../Common/Axios/axiosInstanceClient";
import API from "../../Common/Endpoint/serviceConstrants";
import {
  ApiRespCode,
  CardDataSlice,
  ClientInfo,
  formatPrice,
  GetImageUrl,
  GetOrderCodeReducer,
  LoginV3Data,
  OrderData,
  ParseInt,
  ThemeData,
  useClientConfigFlag,
  VendorData,
} from "../Utility/Utility";
import Loader from "../Loader/Loader";
import { handleVedorOrder } from "../OrderUtility/OrderUitlity";
import { onGetOrder } from "../../Store/Slices/orderSlice";
import { useLocation } from "react-router-dom";
import { onPostVendorOrderReset } from "../../Store/Slices/vendorOrderSlice";

import { useRef } from "react";
import OrderAlternatePage from "../OrderConfirmation/orderAlternatePage";
import { onProductByProductIdSubmit } from "../../Store/Slices/productSlice";
import {
  getPointsRedeemStatus,
  isRewardStatusNotApplicable,
} from "../Utility/rewardStatus";

const GiftcardSummary = () => {
  const dispatch = useDispatch();
  const cardData = CardDataSlice();
  const orderCodeData = GetOrderCodeReducer();
  const orderDetails = cardData;
  const location = useLocation();
  const clientInfo = ClientInfo();
  const loginV3Data = LoginV3Data();
  const vendorData = VendorData();
  const translation = getTranslationData();
  const orderData = OrderData();
  const themeData = ThemeData();
  const flow2 = clientInfo?.otpConfig === 2;
  const [loading, setLoading] = useState(false);
  const [showOrderFailed, setShowOrderFailed] = useState(false);
  const [showOrderProccess, setShowOrderProcess] = useState(false);
  const [orderDataUrl, setOrderDataUrl] = useState();
  const [showVendorOrderFailed, setVendorShowOrderFailed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [copiedCardIndex, setCopiedCardIndex] = useState(null);
  const [expandedIndex, setExpandedIndex] = useState([]);
  const hasAutoExpanded = useRef(false);
  const selectedProductId = location?.state?.productId;
  const [openInst, setOpenInst] = useState(false);
  const [openRedeem, setOpenRedeem] = useState(false);
  const [openTermsCon, setOpenTermsCon] = useState(false);
  const selectedProduct = useSelector((state) => state.productReducer?.productByProductId?.[0]);
  const giftCardData =
    orderCodeData?.OrderCodeData?.[0]?.giftCode &&
    decryptAES(orderCodeData?.OrderCodeData?.[0]?.giftCode);
  const orderMainData = orderCodeData?.OrderCodeData?.[0];

  // Order summary card is shown only when the client enables it in config.
  const showOrderSummary = useClientConfigFlag("isOrderSummaryDisplay");
  const [summaryOrder, setSummaryOrder] = useState(null);
  const [openOrderSummary, setOpenOrderSummary] = useState(true);

  const normalizeUrl = (value) => {
    if (typeof value !== "string") {
      return null;
    }

    const trimmedValue = value.trim();
    if (
      !trimmedValue ||
      trimmedValue.toLowerCase() === "null" ||
      trimmedValue.toLowerCase() === "undefined"
    ) {
      return null;
    }

    return trimmedValue;
  };

  const getVisitNowUrl = (product) => {
    const affiliateUrl = normalizeUrl(selectedProduct?.affiliateLink);

    const redirectionUrl = normalizeUrl(product?.RedemptionUrl?.Url);

    return affiliateUrl || redirectionUrl;
  };

  const handleResize = () => {
    setIsMobile(window.innerWidth < 992);
  };
  useEffect(() => {
    flow2 && setLoading(true);
    dispatch(onGeOrderCodeReset());
    dispatch(onProductByProductIdSubmit(selectedProductId));
    if (clientInfo?.otpConfig === 1) {
      dispatch(
        onGetOrderCode({
          id: orderDetails?.orderId,
          deno: orderDetails?.productData?.denomination,
          customerId: loginV3Data?.memberIdentifier,
        })
      );
    } else {
      if (!location?.state?.orderData?.orderId) {
        const encData = window.location.search.slice(1);
        const decData = decryptAES(encData);
        const params = new URLSearchParams(decData);

        const orderId = params.get("orderId");
        const orderNumber = params.get("orderNumber");
        const denomination = params.get("denomination");
        setOrderDataUrl({
          orderId,
          orderNumber,
          denomination,
        });
        dispatch(onGetOrder({ id: orderId, isOrder: true }));
      } else {
        dispatch(onGetOrder({ id: location?.state?.orderData?.orderId, isOrder: true }));
      }
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (flow2) {
      if (orderData?.status_code === ApiRespCode.v3Create) {
        if (
          orderData?.orderData?.orders?.[0]?.vendorOrderStatus?.toLowerCase() ===
          "COMPLETE".toLowerCase()
        ) {
          setLoading(false);
          setShowOrderFailed(false);
          dispatch(
            onGetOrderCode({
              id: location?.state?.orderData?.orderId || orderDataUrl?.orderId,
              deno: location?.state?.orderData?.denomination || orderDataUrl?.denomination,
              customerId: loginV3Data?.memberIdentifier,
            })
          );
        } else if (
          orderData?.orderData?.orders?.[0]?.vendorOrderStatus === "Pending"
        ) {
          const vendorPayload = {
            orderId: orderData?.orderData?.orders?.[0]?.orderNumber,
            supplierCode: orderData?.orderData?.orders?.[0]?.supplierCode,
            amount: orderData?.orderData?.orders?.[0]?.products?.reduce(
              (total, item) => total + item.denomination * item.qty,
              0
            ),
            products: orderData?.orderData?.orders?.[0]?.products?.map(
              ({ sku, denomination, qty }) => ({
                sku,
                denomination,
                qty,
              })
            ),
          };
          handleVedorOrder(dispatch, vendorPayload);
          setLoading(false);
        } else if (
          orderData?.orderData?.orders?.[0]?.orderStatus === "Failed"
        ) {
          setShowOrderFailed(true);
          setLoading(false);
        } else if (
          orderData?.orderData?.orders?.[0]?.vendorOrderStatus.toLowerCase() ===
          "Processing".toLowerCase()
        ) {
          setShowOrderProcess(true);
          setLoading(false);
        }
      }
    }
  }, [orderData]);

  useEffect(() => {
    if (vendorData?.post_status_code === ApiRespCode.create) {
      setLoading(false);
      setShowOrderProcess(false);
      dispatch(
        onGetOrderCode({
          id: location?.state?.orderId || orderDataUrl?.orderId,
          deno: location?.state?.denomination || orderDataUrl?.denomination,
          customerId: loginV3Data?.memberIdentifier,
        })
      );
      dispatch(onPostVendorOrderReset());
    } else if (
      vendorData?.post_status_code !== null &&
      !vendorData?.post_status_code === ApiRespCode.get
    ) {
      setShowOrderProcess(false);
      setShowOrderFailed(true);
      setLoading(false);
      setVendorShowOrderFailed(true);
      dispatch(onPostVendorOrderReset());
    } else if (
      vendorData?.post_status_code !== null &&
      vendorData?.post_status_code === ApiRespCode.get
    ) {
      setShowOrderProcess(true);
      setLoading(false);
      dispatch(onPostVendorOrderReset());
    }
  }, [vendorData]);

  const summaryOrderId =
    location?.state?.orderData?.orderId ||
    orderDetails?.orderId ||
    location?.state?.orderId ||
    orderDataUrl?.orderId;

  // Order-level totals (date, cash, points) come from the member order API, not from /order-code.
  useEffect(() => {
    if (!showOrderSummary || !summaryOrderId) return;

    // In flow2 this page already loads the order itself, so reuse it instead of calling again.
    const fetchedOrder = orderData?.orderData?.orders?.[0];
    if (flow2 && fetchedOrder?.orderId === summaryOrderId) {
      setSummaryOrder(fetchedOrder);
      return;
    }

    let isActive = true;
    axiosInstanceClient
      .get(API.memberOrder, { params: { orderId: summaryOrderId } })
      .then(({ data }) => {
        const order = data?.response?.orders?.[0];
        if (isActive && order) setSummaryOrder(order);
      })
      .catch(() => {
        // Card stays hidden if the order can't be fetched; gift codes still render.
      });
    return () => {
      isActive = false;
    };
  }, [showOrderSummary, summaryOrderId, orderData?.orderData]);

  const summaryQuantity = summaryOrder?.products?.reduce(
    (total, item) => total + (Number(item?.qty) || 0),
    0
  );
  const summaryCash = Number(summaryOrder?.amount) || 0;
  const summaryPoints = Number(summaryOrder?.totalBurn) || 0;
  const showSummaryRedeemedPoints = !isRewardStatusNotApplicable(
    getPointsRedeemStatus(summaryOrder),
  );

  const formatSummaryDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date)) return "";
    return date
      .toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
      .replace(",", "");
  };

  useEffect(() => {
    if (!hasAutoExpanded.current && giftCardData?.length > 0) {
      setExpandedIndex(giftCardData.map((_, i) => i));
      hasAutoExpanded.current = true;
    }
  }, [giftCardData]);

  const toggleExpand = (index) => {
    expandedIndex.includes(index)
      ? setExpandedIndex(expandedIndex.filter((i) => i !== index))
      : setExpandedIndex([...expandedIndex, index]);
  };

  const handleCopy = (product, index) => {
    navigator.clipboard.writeText(product);
    setCopiedCardIndex(index);
    setTimeout(() => setCopiedCardIndex(null), 3000);
  };
  const [openIndexes, setOpenIndexes] = useState([]);

  const toggle = (index) => {
    setOpenIndexes((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };
  return (
    <>
      {orderCodeData?.isGetLoading || vendorData?.isPostLoading || loading ? (
        <Loader />
      ) : (
        <div className="bg light_bg_white">
          <BackSections />
          <section className="mt-4 m-2 egiftcard_banner">
            <div className="container p-2">
              <div className="row justify-content-center">
                <div className="col-lg-10 col-12">
                  <div className="bg-pink2">
                    <div
                      className={`p-2 ${isMobile ? "" : "gift-header-container"
                        }`}
                    >
                      <div className="thankyoubox2">
                        <p className="onepgift gift-head-colr">
                          <img
                            src={
                              themeData?.imageUrl
                                ? GetImageUrl(themeData?.imageUrl)
                                : yourCard
                            }
                            alt="Your E-Gift Cards"
                          />{" "}
                          &nbsp;
                          {translation?.yourEGiftCards}
                        </p>
                      </div>
                      <div className="d-flex d-md-flex d-none">
                        <div className="ps-2">
                          <span className="text-muted font-sm order-num text-end">
                            {translation.orderNumber}
                          </span>
                          <span className="ps-2 gift-pri text-end">
                            {location?.state?.orderData?.orderId
                              ? location?.state?.orderData?.orderId
                              : orderDetails?.orderId
                                ? orderDetails?.orderId
                                : orderDataUrl?.orderId}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="order_summary_section">
            {/* The order summary card already shows the order number */}
            {!(showOrderSummary && summaryOrder && giftCardData?.length > 0) && (
              <div className="order_numbar_section d-md-none">
                <span className="font-sm order-num ">
                  {translation?.orderNumber}
                </span>
                <span className="ps-2 gift-pri">
                  {" "}
                  {location?.state?.orderData?.orderId
                    ? location?.state?.orderData?.orderId
                    : orderDetails?.orderId
                      ? orderDetails?.orderId
                      : orderDataUrl?.orderId}
                </span>
              </div>
            )}

            <div className="container minhight order_summary_accordion">
              <div className="row justify-content-center">
                {showOrderSummary && summaryOrder && giftCardData?.length > 0 && (
                  <div className="col-lg-10 col-12 mb-4">
                    <div className="order-summary-card">
                      <div
                        className="order-summary-header"
                        onClick={() => setOpenOrderSummary(!openOrderSummary)}
                      >
                        <span className="order-summary-title">
                          {translation?.orderSummaryTitle}
                        </span>
                        <i
                          className={`fa-solid ${openOrderSummary ? "fa-angle-up" : "fa-angle-down"}`}
                        ></i>
                      </div>
                      {openOrderSummary && (
                        <div className="order-summary-body">
                          <div className="order-summary-row">
                            <span className="order-summary-label">
                              {translation?.orderNumber}
                            </span>
                            <span className="order-summary-value">
                              #{summaryOrder?.orderId}
                            </span>
                          </div>
                          {summaryOrder?.createdOn && (
                            <div className="order-summary-row">
                              <span className="order-summary-label">
                                {translation?.purchasedOn}
                              </span>
                              <span className="order-summary-value">
                                {formatSummaryDate(summaryOrder?.createdOn)}
                              </span>
                            </div>
                          )}
                          {summaryQuantity > 0 && (
                            <div className="order-summary-row">
                              <span className="order-summary-label">
                                {translation?.orderSummaryQuantity}
                              </span>
                              <span className="order-summary-value order-summary-qty">
                                {summaryQuantity} {translation?.cardsLabel}
                              </span>
                            </div>
                          )}
                          {summaryCash > 0 && (
                            <div className="order-summary-row">
                              <span className="order-summary-label">
                                {translation?.cashAmount}
                              </span>
                              <span className="order-summary-value order-summary-cash">
                                ₹{formatPrice(summaryCash)}
                              </span>
                            </div>
                          )}
                          {showSummaryRedeemedPoints && summaryPoints > 0 && (
                            <div className="order-summary-row">
                              <span className="order-summary-label">
                                {translation?.pointsRedeemed}
                              </span>
                              <span className="order-summary-value order-summary-points">
                                <img src={pointiconImage} alt="" aria-hidden="true" />
                                {Math.round(summaryPoints).toLocaleString("en-IN")}
                              </span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {giftCardData &&
                  giftCardData?.map((product, index) => {
                    const visitNowUrl = getVisitNowUrl(product);

                    return (
                      <div className="col-lg-5 col-12 mb-4" key={index}>
                        <div className="accordion" id="accordionExample">
                          <div className="its-card border-rad">
                            <h2
                              className="accordion-header"
                              id={`heading${index}`}
                            >
                              <button
                                className={`accordion-button d-flex align-items-center ${openIndexes.includes(index) ? "collapsed" : ""
                                  }`}
                                type="button"
                                aria-expanded={openIndexes.includes(index)}
                                aria-controls={`collapse${index}`}
                                onClick={() => toggle(index)}
                              >
                                {/* <i
                                className={`fas bot-icon ${expandedIndex.includes(index)
                                  ? "fa-chevron-down"
                                  : "fa-chevron-up"
                                  }`}
                              ></i> */}

                                <div className="d-flex justify-content-between align-items-center w-100 me-2">
                                  <span className="gift-pri">
                                    {orderMainData?.name}
                                  </span>
                                  <span className="gift-pri">
                                    ₹{ParseInt(product?.Amount)}
                                  </span>
                                </div>
                              </button>
                            </h2>

                            <div
                              className={`accordion-collapse collapse ${openIndexes.includes(index) ? "" : "show"
                                }`}
                              id={`collapse${index}`}
                              aria-labelledby={`heading${index}`}
                            >
                              <div className="position-relative">
                                {copiedCardIndex === index && (
                                  <span className="copy-message-overlay">
                                    {translation?.copiedSuccessfully}
                                  </span>
                                )}
                                <div className="accordion-body">
                                  <div className="d-flex justify-content-between">
                                    {product?.CardNumber?.length > 0 && (
                                      <div className="copycode">
                                        <p className="codetitle">
                                          {product?.labels?.cardNumber}
                                        </p>
                                        <p className="giftcode1">
                                          {product?.CardNumber}
                                          &nbsp;
                                          <span
                                            onClick={() =>
                                              handleCopy(
                                                product?.CardNumber,
                                                index
                                              )
                                            }
                                          >
                                            <img
                                              src={copyIcon}
                                              alt={"copy-icon"}
                                              className="copy-icon"
                                            />
                                          </span>
                                        </p>
                                      </div>
                                    )}
                                    {product?.Barcode ? (
                                      <div className="qrcodeimg">
                                        <img
                                          className="qr-sz"
                                          src={qr}
                                          alt="QR Code"
                                        />
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                  <div className="d-flex justify-content-between mt-3 mb-3">
                                    {product?.CardPin?.length > 0 && (
                                      <div className="copycode">
                                        <p className="codetitle">
                                          {product?.labels?.cardPin}
                                        </p>
                                        <p className="giftcode">
                                          {product?.CardPin}&nbsp;
                                          <span
                                            onClick={() =>
                                              handleCopy(product?.CardPin, index)
                                            }
                                          >
                                            <img
                                              src={copyIcon}
                                              alt={"copy-icon"}
                                              className="copy-icon"
                                            />
                                          </span>
                                        </p>
                                      </div>
                                    )}
                                    <div
                                      className={`copycode txt-right ${product?.CardPin?.length ? "txt-dir" : ""
                                        }`}
                                    >
                                      <p className="codetitle">
                                        {translation?.expDate}
                                      </p>
                                      <p className="giftcode">
                                        {new Date(
                                          product?.Validity
                                        ).toLocaleDateString("en-GB")}
                                      </p>
                                    </div>
                                  </div>
                                  {visitNowUrl ? (
                                    <>
                                      {" "}
                                      <hr />
                                      <div
                                        className="d-flex justify-content-between"
                                        onClick={() =>
                                          window.open(
                                            visitNowUrl,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <div className="copycode">
                                          <p className="gifttry gradient_text_bronze">
                                            {translation?.visitNow} &nbsp;{" "}
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="none"
                                              stroke="var(--redeem-text-color)"
                                              strokeWidth="3"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              viewBox="0 0 24 24"
                                            >
                                              <path d="M7 17L17 7M7 7h10v10" />
                                            </svg>
                                            {/* <img src={upright} alt="Try" /> */}
                                          </p>
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
              <div className="col-lg-10 col-12 justify-content-center mx-auto">
                <div className="text-center border-rad">
                  <div className="tnc_redeem_note_box jlkkedit2">
                    <div
                      className="item py-3"
                      onClick={() => setOpenInst(!openInst)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="text .jlkkedit2">
                        {translation?.importantInstructions}
                      </div>
                      <div className="arrow">
                        <i
                          className={`fa-solid ${openInst ? "fa-angle-down" : "fa-angle-right"
                            }`}
                        ></i>
                      </div>
                    </div>
                    {openInst && (
                      <div
                        className="mt-2 mx-2 pd-left text-start"
                        style={{
                          overflowWrap: "break-word",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: selectedProduct?.instructionsContent || "",
                        }}
                      ></div>
                    )}
                    <div
                      className="item py-3"
                      onClick={() => setOpenRedeem(!openRedeem)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="text">{translation?.how_to_use}</div>
                      <div
                        className="arrow"
                        onClick={() => setOpenRedeem(!openRedeem)}
                      >
                        <i
                          className={`fa-solid ${openRedeem ? "fa-angle-down" : "fa-angle-right"
                            }`}
                        ></i>
                      </div>
                    </div>
                    {openRedeem && (
                      <div
                        className="mt-2 mx-2 pd-left text-start"
                        style={{
                          overflowWrap: "break-word",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: selectedProduct?.howToUseContent || "",
                        }}
                      ></div>
                    )}
                    <div
                      className="item py-3"
                      onClick={() => setOpenTermsCon(!openTermsCon)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="text">{translation?.terms_condition}</div>
                      <div
                        className="arrow"
                        onClick={() => setOpenTermsCon(!openTermsCon)}
                      >
                        <i
                          className={`fa-solid ${openTermsCon ? "fa-angle-down" : "fa-angle-right"
                            }`}
                        ></i>
                      </div>
                    </div>
                    {openTermsCon && (
                      <div
                        className="mt-2 mx-2 pd-left text-start"
                        style={{
                          overflowWrap: "break-word",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: selectedProduct?.tncContent || "",
                        }}
                      ></div>
                    )}
                  </div>
                </div>
              </div>
              {(showOrderFailed || showVendorOrderFailed) && flow2 && (
                <section className="mt-4 m-2">
                  <div className="container p-2">
                    <div className="row justify-content-center">
                      <div className="col-lg-10 col-12">
                        <div className="bg-pink2">
                          <div
                            className={`p-2 ${isMobile ? "" : "gift-header-container-center"
                              }`}
                          >
                            <div className="thankyoubox2">
                              <b>
                                {" "}
                                <i className="fa-solid fa-circle-exclamation"></i>{" "}
                                {showVendorOrderFailed &&
                                  translation.vendor_order_failed_orderdetails}
                                {showOrderFailed &&
                                  translation.order_failed_orderdetails}
                                {showOrderProccess &&
                                  translation.order_proccessing_message}
                              </b>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}
              {showOrderProccess && (
                <div className="row justify-content-center">
                  <OrderAlternatePage />
                </div>
              )}
            </div>
          </section>
        </div>
      )}
    </>
  );
};

export default GiftcardSummary;
